module.exports = __webpack_public_path__ + "img/hdfcred-img.99fa7abf.png";